var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboardHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8017_7323)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_8017_7323)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8017_7323",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8017_7323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 0H1.875C1.37772 0 0.900806 0.197544 0.549175 0.549175C0.197544 0.900806 0 1.37772 0 1.875V6.875H9.375V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 0H10.625V6.875H15V1.875C15 1.37772 14.8024 0.900806 14.4508 0.549175C14.0991 0.197544 13.6222 0 13.125 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 8.12524H0V13.1252C0 13.6226 0.197544 14.0994 0.549175 14.4511C0.900806 14.8027 1.37772 15.0002 1.875 15.0002H4.375V8.12524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8.12524H5.625V15.0002H13.125C13.6222 15.0002 14.0992 14.8027 14.4508 14.4511C14.8024 14.0994 15 13.6226 15 13.1252V8.12524Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_8017_7323",
    x: 0,
    y: 0,
    width: 15,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_8017_7323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8017_7323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboardHover);
export default __webpack_public_path__ + "static/media/Menu-Dashboard-hover.0e73fc2dd678d0448ccd6b7d3cda5bf3.svg";
export { ForwardRef as ReactComponent };